import { resolveRoute } from '@/core/routing/resolve-route';
import { RouteResolver } from '@/core/types/route-resolver';
import { store } from '@/store';
import { getModule } from 'vuex-module-decorators';
import CoreStore from '@/core/store';
import ProfileStore from '@/profile/store';

const coreStore = getModule(CoreStore, store);
const profileStore = getModule(ProfileStore, store);

export const profileRouteResolver = (...resolvers: RouteResolver[]) => resolveRoute({
	pre: () => {
		profileStore.setIsPageLoaderShown(true);
		profileStore.setIsPageErrorShown(false);
	},
	post: () => {
		profileStore.setIsPageLoaderShown(false);
		coreStore.setIsPageLoaderShown(false);
		window.scrollTo(0, 0);
	},
	errorHandler: (error: Error) => {
		profileStore.setIsPageLoaderShown(false);
		coreStore.setIsPageLoaderShown(false);
		profileStore.setIsPageErrorShown(true);
		console.error(error);
	},
	resolvers: [...resolvers],
});
